/**
 * Qué pestaña de «Mis ausencias» se abre.
 *
 * `?tipo=` la elige al llegar, igual que en Aprobaciones. Es por los correos: el
 * botón de un permiso enviado o de una incapacidad validada llevaba a `/ausencias`,
 * y la pantalla abría siempre Vacaciones, así que el permiso no estaba donde el
 * correo decía. Lo que la persona elija después manda sobre la URL: la URL dice
 * por dónde entró, no dónde está.
 */

export type AbsenceTab = 'vacaciones' | 'incapacidades' | 'permisos';

export const activeAbsenceTab = ({
  visible,
  chosen,
  search,
}: {
  /** Las pestañas que esta sesión puede ver, en orden. */
  readonly visible: readonly AbsenceTab[];
  /** La que eligió a mano, si eligió alguna. */
  readonly chosen: AbsenceTab | null;
  /** `location.search`, con o sin `?`. */
  readonly search: string;
}): AbsenceTab => {
  if (chosen !== null && visible.includes(chosen)) return chosen;
  const requested = new URLSearchParams(search).get('tipo');
  const fromUrl = visible.find((tab) => tab === requested);
  // Lo primero que se vea, y no un id fijo: sin Vacaciones o con un módulo
  // apagado la pantalla igual aterriza en algo.
  return fromUrl ?? visible[0] ?? 'vacaciones';
};
